/* ==========================================================================
   THE DEVICE LIST IS GROUPED BY SERIES

   A flat list of sixteen handsets asks the shopper to scan for their own model
   with nothing to hold on to, and "iPhone 17 Pro" sits one row from "iPhone 17
   Pro Max" - which is how the wrong case gets bought. A heading per generation
   gives the eye somewhere to land first.

   This used to live inline in sections/main-product.liquid, which meant it ran
   on product pages and nowhere else - so the identical selector on the home
   page had none of it. It is one shared file now, and both pages get exactly
   the same list.

   Only lists whose values actually parse as "iPhone <n>" are touched, so a
   colour popover is left alone. Idempotent: popovers get re-rendered.
   ========================================================================== */
(function () {
  "use strict";

  function label(n) {
    var t = window.gcSeriesLabel;
    if (typeof t === "string" && t.indexOf("{n}") !== -1) return t.replace("{n}", n);
    return "iPhone " + n + " series";
  }

  function group(list) {
    if (!list || list.getAttribute("data-gc-grouped") === "1") return;
    var items = Array.prototype.slice.call(list.querySelectorAll(".Popover__Value"));
    if (items.length < 4) return;
    var parsed = 0;
    var last = null;
    items.forEach(function (btn) {
      var m = /iPhone\s+(\d+)/i.exec(btn.textContent || "");
      if (!m) return;
      parsed++;
      if (m[1] === last) return;
      last = m[1];
      var h = document.createElement("div");
      h.className = "gc-popover-group";
      h.setAttribute("aria-hidden", "true");
      h.textContent = label(m[1]);
      list.insertBefore(h, btn);
    });
    /* if hardly anything parsed this is not a device list - undo */
    if (parsed < items.length / 2) {
      list.querySelectorAll(".gc-popover-group").forEach(function (n) { n.remove(); });
      return;
    }
    list.setAttribute("data-gc-grouped", "1");
  }

  function boot() {
    document.querySelectorAll(".OptionSelector .Popover__ValueList").forEach(group);
  }

  /* the home page picker builds its list from JSON after this file has run, so
     it calls this itself once the options exist */
  window.gcGroupPopovers = boot;

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  /* re-group after the theme rebuilds a popover */
  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest(".ProductForm__SelectorButton")) window.setTimeout(boot, 120);
  }, true);
})();
